"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListNode = exports.ListItemType = void 0;
var Common_1 = require("./Common");
var ListItemType;
(function (ListItemType) {
    ListItemType["Bullet"] = "bullet";
    ListItemType["Number"] = "number";
})(ListItemType = exports.ListItemType || (exports.ListItemType = {}));
exports.ListNode = {
    isListNode: function (node) {
        return node.type === Common_1.BlockType.ListItem;
    },
};
